import { condensedStyles } from '../condensed-layout';

const overrideDialog = (theme) => {
  theme.overrides.MuiDialog = {
    paperWidthMd: {},
    // The condensed layout caps the design widths instead, so a dialog fits a narrower viewport.
    paperWidthLg: {
      width: 720,
      minHeight: 290,
      ...condensedStyles(theme, { width: '100%', maxWidth: 720 })
    },
    paperWidthSm: {
      width: 418,
      ...condensedStyles(theme, { width: '100%', maxWidth: 418 })
    }
  };
};

export default overrideDialog;
